import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import DialogContent from "@mui/material/DialogContent";

import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControl,
  Grid,
  IconButton,
  ListItemText,
  Modal,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  TextField,
  styled,
  Dialog,
  DialogTitle,
  DialogContentText,
  DialogActions,
  InputLabel,
} from "@mui/material";
import MuiMenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import DownloadIcon from "./../Assests/download.svg";
import UploadIcon from "./../Assests/upload.svg";
import DuplicateIcon from "./../Assests/duplicate-scenario.svg";
import EditScenario from "./../Assests/edit-scenario.svg";
import ReRun from "./../Assests/rerun-icon.svg";
import ReRun1 from "./../Assests/rerun-disabled.svg";

import excelIcon from "./../Assests/excel-icon.png";
import arrowIcon from "./../Assests/arrow-white.png";
import useMediaQuery from "@mui/material/useMediaQuery";
import InfoIcon from "@mui/icons-material/Info";
import UploadModal from "./Modals/UploadModal";
import CancelIcon from "@mui/icons-material/Close";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import * as actions from "./../Redux/Actions/index";
import {
  closeModal,
  goBack,
  cloaseDonePopup,
  openErrorDialog,
  displayScenarioList,
  displayScenarioListSuccess,
  displayScenarioListError,
  displayFolderList,
  displayFolderListError,
  displayFolderListSuccess,
  selectedScenarioListSuccess,
  selectedFolderListSuccess,
  displayDashboardSummaryCost,
  displayDashboardSummaryCostSuccess,
  displayDashboardSummaryCostError,
  displayMonthNamesListSuccess,
  selectedCategoryListSuccess,
  selectedUploadFolderListSuccess,
  selectedUsecaseListSuccess,
  selectedTimePeriodSuccess,
  openErrorOrWarningDialog,
  nutritionDisplayDashboardSummaryCost,
  nutritionDisplayDashboardSummaryCostSuccess,
  nutritionDisplayDashboardSummaryCostError,
  enableEditFilter,
  fileUploadStatus,
  enableEditPopupForSave,
  createrFolderOrScenarioError,
  uploadBaseLineData,
} from "./../Redux/Actions/InputData";
import DuplicateScenario from "./Modals/DuplicateScenario";
import BaseLineUploading from "./Modals/BaseLineUploading";
import DoneDialog from "./Modals/DoneDialog";
import ErrorDialog from "./Modals/ErrorDialog";
import _ from "underscore";
import "./style.css";
import { getRequest, postRequest } from "../Services/AxiosConfiguration";
import {
  API_BASE_URL,
  DISPLAY_SCENARIO_FILTER_API,
  DISPLAY_SUMMARY_COST_DASHBOARD,
  NUTRITION_DISPLAY_SUMMARY_COST_DASHBOARD,
  // GET_SAS_URI_API,
  DOWNLOAD_GUROBI_API,
  DISPLAY_MONTH_NAMES_API,
  NUTRITION_DISPLAY_MONTH_NAMES_API,
  USECASE_DETAILS_API,
  CATEGORY_DETAILS_API,
  // DISPLAY_FOLDER_LIST_BY_USECASE_API,
  DISPLAY_FOLDER_LIST_BY_USECASE_AND_USERID_API,
  NUTRITION_DOWNLOAD_GUROBI_API,
  MEDIUM_DOWNLOAD_GUROBI_API,
  MEDIUM_DISPLAY_SUMMARY_COST_DASHBOARD,
  MEDIUM_NUTRITION_DISPLAY_SUMMARY_COST_DASHBOARD,
  NUTRITION_MEDIUM_DOWNLOAD_GUROBI_API,
  MEDIUM_HOME_DISPLAY_MONTH_NAMES_API,
  MEDIUM_NUTRITION_DISPLAY_MONTH_NAMES_API,
  SHORT_TERM_HOMECARE_API,
  RERUN_EDIT_HOMECARE_DETAILS_API,
  RERUN_EDIT_NUTRITION_DETAILS_API,
  RERUN_HOMECARE_DETAILS_API,
  RERUN_NUTRITION_DETAILS_API,
  PROGRESS_BAR_DETAILS_API,
  RERUN_PROGRESS_BAR_DETAILS_API,
  RERUN_MEDIUM_HOMECARE_DETAILS_API,
  RERUN_MEDIUM_NUTRITION_DETAILS_API,
  LONG_GETALLFOLDERS_API,
  LONG_GETALLSCENARIOS_API,
  LONG_GETALLTIMEPERIODS_API,
  LONG_TERM_ALL_DOWNLOAD,
  LONG_SUMMARY_COST_PER_DASHBOARD_API,
  LONG_ADD_FOLDERSCENARIO_GET_API,
  LONG_ADD_SCENARIO_GET_API,
  LONG_TERM_ALL_DOWNLOAD3,
  LONG_TERM_ALL_DOWNLOAD4,
  LONG_TERM_ALL_DOWNLOAD5,
  LONG_TERM_ALL_DOWNLOAD6,
  LONG_TERM_ALL_DOWNLOAD2,
  RERUN_LONGTERM_API,
  GET_LONGTERM_TIMEPERIOD_API,
  GET_LONGTERM_RERUN_UPLOAD_API,
} from "../Utils/Config";
import axios from "axios";
import FileSaver from "file-saver";
import { BlobServiceClient } from "@azure/storage-blob";
import ErrorOrWarningDialog from "./Modals/ErrorOrWarningDialog";
import ReplayIcon from "@mui/icons-material/Replay";
import Loader from "./Modals/Loader";
import SaveIcon from "@mui/icons-material/Save";
import { useTheme } from "@mui/material/styles";
import InputCapacityModal from "./Modals/LongTerm/InputCapacityModal";
import FolderModal from "./Modals/LongTerm/FolderModal";
import LongTermUploadModal from "./Modals/LongTerm/LongTermUploadModal";
import { addProcessingPackagingPlantsDiff } from "../Redux/Actions/InputData";
import { addSourceBePartOfOptimization } from "../Redux/Actions/InputData";
import { addPackingPlantAddMinorIngredient } from "../Redux/Actions/InputData";
import { ActivateOrDeactivateFolder } from "../Services/FolderService";
const MenuItem = styled(MuiMenuItem)(({ theme }) => ({
  "& .MuiSvgIcon-root": {
    marginRight: theme.spacing(1),
  },
}));

function pickValidFolderId(
  uploadId: unknown,
  selectedId: unknown,
): number | string | undefined {
  const isValid = (v: unknown) =>
    v !== undefined &&
    v !== null &&
    v !== "" &&
    Number(v) !== 0;
  if (isValid(uploadId)) return uploadId as number | string;
  if (isValid(selectedId)) return selectedId as number | string;
  return undefined;
}

function FilterComponent(props: any) {
  const modelRef = useRef(null);
  const navigate = useNavigate();
  const dispatch: any = useDispatch();
  const hiddenFileInput: any = React.useRef(null);
  const [isOpenUploadHomeModal, setIsUploadHomeModal] = useState(false);
  const [selectTimePeriod, setSelectTimePeriod] = useState<string[]>([]);
  const [selectScenario, setSelectScenario] = useState<any>("");
  const [selectFolder, setSelectFolder] = useState<any>("");
  const [selectUsecase, setSelectUsecase] = useState<any>("Use Case");
  const [selectCategory, setSelectCategory] = useState<any>("Category");
  const [sasUri, setSasUri] = useState("");
  const [reRun, setReRun] = useState("");
  const [openForEdit, setOpenForEdit] = React.useState(false);
  const [selectedUsecaseeId, setSelectedUsecaseId] = useState<any>(0);
  const [selectedScenarioId, setSelectedScenarioId] = useState<any>();
  const [selectedFolderId, setSelectedFolderId] = useState<any>();
  // const [selectedUploadFolderId, setselectedUploadFolderId] = useState<any>();
  const [selectedCategoryId, setSelectedCategoryId] = useState<any>(0);
  const [duplicateScenario, setDuplicateScenario] = useState<any>(false);
  const [isOpenBaseLineUploader, setIsOpenBaseLineUploader] = useState(false);
  const [isUploadMasterFile, setIsUploadMasterFile] = React.useState(false);
  const [isFileUploadStatus, setIsFileUploadStatus] = React.useState(false);
  const [isEditFileStatus, setIsEditFileStatus] = React.useState(false);
  const [isEdit, setIsEdit] = React.useState(true);
  const [isNext, setIsNext] = React.useState(false);
  const [selectRadio, setSelectRadio] = React.useState("");
  const [usecaseOptions, setUsecaseOptions] = React.useState([]);
  const [categoryOptions, setCategoryOptions] = useState<any>([]);
  const [folderOptions, setFolderOptions] = useState<any>([]);
  const [scenarioOptions, setScenarioOptions] = useState<any>([]);
  const [monthNameOptions, setMonthNamesOptions] = useState<any>([]);
  const [nutritionMonthNameOptions, setNutritionMonthNamesOptions] =
    useState<any>([]);

  const [selectedfile, setSelectedFile] = useState<any>({});
  const [selectedfileList, setSelectedFileList] = useState<any>([]);
  const [selectedItemId, setSelectedItemId] = useState("");
  const [uploadStatusData, setUploadStatusData] = useState<any>([]);
  const [rerunUploadStatusData, setRerunUploadStatusData] = useState<any>([]);
  const [reRunStatus, setReRunStatus] = useState<any>("");
  const [reRunSuccess, setReRunSuccess] = React.useState(false);
  const [uploadId, setUploadId] = React.useState("");
  const [showMasterDataModal, setShowMasterDataModal] = useState(false);

  // states for file upload LT
  const [openInputCapacityModalForLT, setOpenInputCapacityModalForLT] =
    React.useState(false);
  const [isLongTermUploadModal, setIsLongTermUploadModal] =
    React.useState(false);
  const [isNextFolderModalLongTerm, setIsNextFolderModalLongTerm] =
    React.useState(false);
  const [isOpenProceedModal, setIsOpenProceedModal] = useState(false);

  const selectedUsecaseId = useSelector(
    (state: any) => state.InputDataReducers.selectedUsecaseId,
  );

  const selectedCategoryIdd = useSelector(
    (state: any) => state.InputDataReducers.selectedCategoryId,
  );

  const sortedScenarioNames = scenarioOptions.sort((a: any, b: any) =>
    a?.scenario.localeCompare(b?.scenario),
  );

  const sortedFolderNames = folderOptions.sort((a: any, b: any) =>
    a?.folder.localeCompare(b?.folder),
  );
  const [isDownLoadDisable, setIsDownLoadDisable] = useState<any>(false);

  // Short term master file upload(homecare)
  const homeMasterData: any = [
    {
      id: 1,
      name: "Upload input file*",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
      align: "left",
      headerAlign: "left",
    },
  ];

  // Short term input file upload(homecare)
  const homeInputLine: any = [
    {
      id: 1,
      name: "Upload input home care file",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
  ];
  // Short term master file upload(nutrition)
  const nutritionMasterData: any = [
    {
      id: 1,
      name: "Upload master nutrition file*",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
  ];

  // Short term input file upload(nutrition)
  const nutritionInputLine = [
    {
      id: 1,
      name: "Upload input nutrition file",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
  ];

  // options for medium term homecase scenario
  const mediumHomeScenario: any = [
    {
      id: 1,
      name: "Upload home scenario file*",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
  ];
  // options for medium term nutrition scenario - c
  const mediumNutritionScenario = [
    {
      id: 1,
      name: "Upload nutrition scenario file",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
  ];

  const masterData: any =
    selectedCategoryIdd !== 2 ? homeMasterData : nutritionMasterData;

  const isCreateFolder = useSelector(
    (state: any) => state.InputDataReducers.isCreateFolder,
  );

  const isUploadScenarioData = useSelector(
    (state: any) => state.InputDataReducers.isUploadScenario,
  );
  const isUploadBaseLineData = useSelector(
    (state: any) => state.InputDataReducers.isUploadBaseLineData,
  );

  const inputFolderValue = useSelector(
    (state: any) => state.InputDataReducers.inputFolderName,
  );

  const { scenarioData, isScenarioCreated } = useSelector(
    (state: any) => state.InputDataReducers,
  );

  const {
    dashboardSummaryCost,
    isDone,
    isLoading,
    uploadMasterFileMessage,
    uploadMasterFileError,
  } = useSelector((state: any) => state.InputDataReducers);

  const isBaseLineUploader = useSelector(
    (state: any) => state.InputDataReducers.isBaseLineUploader,
  );
  const isFolderCreated = useSelector(
    (state: any) => state.InputDataReducers.isFolderCreated,
  );

  const uploadFolderId = useSelector(
    (state: any) => state.InputDataReducers.selectedUpload,
  );

  const selectedTimePeriodData = useSelector(
    (state: any) => state.InputDataReducers.selectedTimePeriodData,
  );

  /**Redux state */
  const uploadSelectedFolderId = useSelector(
    (state: any) => state.InputDataReducers.selectedUploadFolderId,
  );

  const isFileUpload = useSelector(
    (state: any) => state.InputDataReducers.fileUploadStatus,
  );

  const { isFolderSelected, folderSelectionMessage } = useSelector(
    (state: any) => state.InputDataReducers,
  );

  const uploadScenarioId = useSelector(
    (state: any) => state.InputDataReducers.selectedUploadScenarioId,
  );

  const userData = useSelector(
    (state: any) => state.InputDataReducers.apiUserData,
  );
  console.log(userData, "userData");
  const {
    isErrorDialog,
    errorMessage,
    isErrorOrWarningDialog,
    errorOrWarningMessage,
  } = useSelector((state: any) => state.InputDataReducers);

  const isDuplicateScenarioCreated = useSelector(
    (state: any) => state.InputDataReducers.isDuplicateScenarioCreated,
  );

  const isEditEnabled = useSelector(
    (state: any) => state.InputDataReducers.editFilterEnable,
  );

  const isTableloaded = useSelector(
    (state: any) => state.InputDataReducers.isTableloaded,
  );

  const [canEditScenario, setCanEditScenario] = useState(false);

  // suren
  const [showFullOverlay, setfullOverlayDetails] = useState(false);

  let folderModuleName = selectFolder?.slice(0, 7);

  var inputLine: any;
  useEffect(() => {
    if (selectedUsecaseId === 1) {
      if (selectedCategoryIdd === 1) {
        setGetInputLineData(homeInputLine);
      } else {
        setGetInputLineData(nutritionInputLine);
      }
    } else {
      if (selectedCategoryIdd === 2) {
        if (isUploadScenarioData) {
          setGetInputLineData(mediumNutritionScenario);
        } else {
          setGetInputLineData(nutritionInputLine);
        }
      } else {
        if (isUploadScenarioData) {
          setGetInputLineData(mediumHomeScenario);
        } else {
          setGetInputLineData(homeInputLine);
        }
        // setGetInputLineData(isUploadScenarioData ? mediumHomeScenario : homeInputLine);
      }
    }
  }, [selectedUsecaseId, selectedCategoryIdd, isUploadScenarioData]);

  const [getMasterData, setGetMasterData] = useState(masterData);
  const [getInputLineData, setGetInputLineData] = useState(inputLine);

  const [selectedfilesList, setSelectedFilesList] = useState<any>([]);
  const [isUploadReady, setIsUploadReady] = useState<any>(false);
  const [openEditDialog, setOpenEditDialog] = useState<any>(false);
  const [openReRunDialog, setOpenReRunDialog] = useState<any>(false);
  const [uploadReRunStatus, setUploadReRunStatus] = useState<any>(false);
  const [openReRunDialogStatus, setOpenReRunDialogStatus] = useState<any>("");
  const [reRunDialogStatus, setReRunDialogStatus] = useState<any>("");
  const [fileTypeName, setFileTypeName] = useState<any>("");

  const [loader, setLoader] = useState<any>(false);

  const getIsProcessingPackagingPlantsDiff = useSelector(
    (state: any) => state.InputDataReducers.isProcessingPackagingPlantsDiff,
  );

  const getIsSourceBePartOfOptimization = useSelector(
    (state: any) => state.InputDataReducers.isSourceBePartOfOptimization,
  );

  const getIsPackingPlantAddMinorIngredient = useSelector(
    (state: any) => state.InputDataReducers.isPackingPlantAddMinorIngredient,
  );
  const [isProcessingPackagingPlantsDiff, setProcessingPackagingPlantsDiff] =
    useState<any>(getIsProcessingPackagingPlantsDiff);
  const [isSourceBePartOfOptimization, setSourceBePartOfOptimization] =
    useState<any>(getIsSourceBePartOfOptimization);
  const [isPackingPlantAddMinorIngredient, setPackingPlantAddMinorIngredient] =
    useState<any>(getIsPackingPlantAddMinorIngredient);
  useEffect(() => {
    setSelectedFileList([]);
    //callFolderFilterApi();
  }, []);

  useEffect(() => {
    if (selectedFolderId !== undefined && selectedFolderId !== 0) {
      const moduleName = selectFolder?.slice(0, 7);

      console.log(moduleName, "moduleNamemoduleName");
      if (moduleName === "module1") {
        setProcessingPackagingPlantsDiff(true);
        setSourceBePartOfOptimization(true);
        setPackingPlantAddMinorIngredient(true);
        dispatch(addProcessingPackagingPlantsDiff(true));
        dispatch(addSourceBePartOfOptimization(true));
        dispatch(addPackingPlantAddMinorIngredient(true));
      } else if (moduleName === "module2") {
        setProcessingPackagingPlantsDiff(true);
        setSourceBePartOfOptimization(false);
        setPackingPlantAddMinorIngredient(true);
        dispatch(addProcessingPackagingPlantsDiff(true));
        dispatch(addSourceBePartOfOptimization(false));
        dispatch(addPackingPlantAddMinorIngredient(true));
      } else if (moduleName === "module3") {
        setProcessingPackagingPlantsDiff(false);
        setSourceBePartOfOptimization(true);
        setPackingPlantAddMinorIngredient(false);
        dispatch(addProcessingPackagingPlantsDiff(false));
        dispatch(addSourceBePartOfOptimization(true));
        dispatch(addPackingPlantAddMinorIngredient(false));
      } else if (moduleName === "module4") {
        setProcessingPackagingPlantsDiff(false);
        setSourceBePartOfOptimization(false);
        setPackingPlantAddMinorIngredient(false);
        dispatch(addProcessingPackagingPlantsDiff(false));
        dispatch(addSourceBePartOfOptimization(false));
        dispatch(addPackingPlantAddMinorIngredient(false));
      } else if (moduleName === "module5") {
        setProcessingPackagingPlantsDiff(true);
        setSourceBePartOfOptimization(true);
        setPackingPlantAddMinorIngredient(false);
        dispatch(addProcessingPackagingPlantsDiff(true));
        dispatch(addSourceBePartOfOptimization(true));
        dispatch(addPackingPlantAddMinorIngredient(false));
      } else if (moduleName === "module6") {
        setProcessingPackagingPlantsDiff(true);
        setSourceBePartOfOptimization(false);
        setPackingPlantAddMinorIngredient(false);
        dispatch(addProcessingPackagingPlantsDiff(true));
        dispatch(addSourceBePartOfOptimization(false));
        dispatch(addPackingPlantAddMinorIngredient(false));
      }
    }
  }, [selectedFolderId]);
  useEffect(() => {
    if (
      selectedFolderId !== undefined &&
      selectedFolderId !== 0 &&
      selectedFolderId !== ""
    ) {
      if (selectedUsecaseId === 1) {
        if (selectedCategoryId === 1) {
          callMonthFilterApi(selectedScenarioId);
        } else {
          nutritionCallMonthFilterApi(selectedScenarioId);
        }
      } else if (selectedUsecaseId === 2) {
        if (selectedCategoryId === 1) {
          mediumHomecallMonthFilterApi(selectedScenarioId);
        } else {
          mediumNutritionCallMonthFilterApi(selectedScenarioId);
        }
      } else {
        callLongTermMonthFilterApi(selectedScenarioId);
      }
    }
    //callFolderFilterApi();
  }, [selectedScenarioId]);

  useEffect(() => {
    if (
      selectedFolderId !== undefined &&
      selectedFolderId !== 0 &&
      selectedFolderId !== ""
    ) {
      callScenarioFilterApi({ id: selectedFolderId });
    }
    //callFolderFilterApi();
  }, [isDuplicateScenarioCreated, isScenarioCreated]);

  useEffect(() => {
    const urls = API_BASE_URL + USECASE_DETAILS_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    getRequest(urls, {}, header)
      .then((response) => {
        if (response.status === 200 && response.data) {
          let responseArray = [];
          responseArray.push(response.data);
          setUsecaseOptions(response.data);
          dispatch(displayScenarioListSuccess(response.data));
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
        dispatch(displayScenarioListError(error.message));
      });
  }, []);

  useEffect(() => {
    const urls = API_BASE_URL + CATEGORY_DETAILS_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    getRequest(urls, {}, header)
      .then((response) => {
        if (response.status === 200 && response.data) {
          setCategoryOptions(response.data);
          dispatch(displayScenarioListSuccess(response.data));
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
        dispatch(displayScenarioListError(error.message));
      });
  }, []);

  var mainStatus = false;

  const callFolderFilterApi = (useCaseId: number, categoryId: number) => {
    if (useCaseId === 3) {
      dispatch(displayFolderList());
      const urls = API_BASE_URL + LONG_GETALLFOLDERS_API;
      const header = {
        accept: "application/json",
        "Content-Type": "application/json",
      };
      getRequest(urls, {}, header)
        .then((response) => {
          if (response.status === 200 && response.data.success) {
            setFolderOptions(response.data.data);
            dispatch(displayFolderListSuccess(response.data.data));
          }
        })
        .catch((error) => {
          dispatch(openErrorDialog(error));
          dispatch(displayFolderListError(error.message));
        });
    } else {
      dispatch(displayFolderList());
      const urls = API_BASE_URL + DISPLAY_FOLDER_LIST_BY_USECASE_AND_USERID_API;
      const header = {
        accept: "application/json",
        "Content-Type": "application/json",
      };
      getRequest(
        urls,
        {
          useCase: useCaseId,
          category: categoryId,
          createdBy: userData.userId,
        },
        header,
      )
        .then((response) => {
          if (response.status === 200 && response.data.success) {
            setFolderOptions(response.data.data);
            dispatch(displayFolderListSuccess(response.data.data));
          }
        })
        .catch((error) => {
          dispatch(openErrorDialog(error));
          dispatch(displayFolderListError(error.message));
        });
    }
  };

  let api: any;
  if (folderModuleName !== "module1") {
    api = LONG_SUMMARY_COST_PER_DASHBOARD_API + folderModuleName;
  } else {
    api = LONG_SUMMARY_COST_PER_DASHBOARD_API;
  }
  const getLongSummaryCostForDashboard = (folderId: any, scenarioId: any) => {
    if (folderId !== 0 || scenarioId !== 0) {
      dispatch(displayDashboardSummaryCost());
      const urls = API_BASE_URL + api;
      const header = {
        accept: "application/json",
        "Content-Type": "application/json",
      };
      getRequest(
        urls,
        {
          usecaseId: 0,
          category_Id: 0,
          folder_id: folderId,
          scenario_id: scenarioId,
        },
        header,
      )
        .then((response) => {
          dispatch(displayDashboardSummaryCostSuccess(response.data));
        })
        .catch((error) => {
          // dispatch(openErrorDialog(error));
          dispatch(displayDashboardSummaryCostError(error.message));
        });
    }
  };

  const getSummaryCostForDashboard = (folderId: any, scenarioId: any) => {
    dispatch(displayDashboardSummaryCost());
    const urls = API_BASE_URL + DISPLAY_SUMMARY_COST_DASHBOARD;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    getRequest(
      urls,
      {
        usecaseId: selectedUsecaseeId,
        category_Id: selectedCategoryId,
        folder_id: folderId,
        scenario_id: scenarioId,
      },
      header,
    )
      .then((response) => {
        // if (response.status === 200 && response.data.success) {
        //   setFolderOptions(response.data.data);
        dispatch(displayDashboardSummaryCostSuccess(response.data));
        // }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(displayDashboardSummaryCostError(error.message));
      });
  };

  const nutritionGetSummaryCostForDashboard = (
    folderId: any,
    scenarioId: any,
  ) => {
    dispatch(nutritionDisplayDashboardSummaryCost());
    const urls = API_BASE_URL + NUTRITION_DISPLAY_SUMMARY_COST_DASHBOARD;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    getRequest(
      urls,
      {
        usecaseId: selectedUsecaseeId,
        category_Id: selectedCategoryId,
        folder_id: folderId,
        scenario_id: scenarioId,
      },
      header,
    )
      .then((response) => {
        dispatch(nutritionDisplayDashboardSummaryCostSuccess(response?.data));
        // }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(nutritionDisplayDashboardSummaryCostError(error.message));
      });
  };

  const MediumgetSummaryCostForDashboard = (folderId: any, scenarioId: any) => {
    dispatch(displayDashboardSummaryCost());
    const urls = API_BASE_URL + MEDIUM_DISPLAY_SUMMARY_COST_DASHBOARD;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    getRequest(
      urls,
      {
        usecaseId: selectedUsecaseeId,
        category_Id: selectedCategoryId,
        folder_id: folderId,
        scenario_id: scenarioId,
      },
      header,
    )
      .then((response) => {
        // if (response.status === 200 && response.data.success) {
        //   setFolderOptions(response.data.data);
        dispatch(displayDashboardSummaryCostSuccess(response.data));
        // }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(displayDashboardSummaryCostError(error.message));
      });
  };

  const MediumnutritionGetSummaryCostForDashboard = (
    folderId: any,
    scenarioId: any,
  ) => {
    dispatch(nutritionDisplayDashboardSummaryCost());
    const urls = API_BASE_URL + MEDIUM_NUTRITION_DISPLAY_SUMMARY_COST_DASHBOARD;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    getRequest(
      urls,
      {
        usecaseId: selectedUsecaseeId,
        category_Id: selectedCategoryId,
        folder_id: folderId,
        scenario_id: scenarioId,
      },
      header,
    )
      .then((response) => {
        dispatch(nutritionDisplayDashboardSummaryCostSuccess(response?.data));
        // }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(nutritionDisplayDashboardSummaryCostError(error.message));
      });
  };

  const handleUploadFile = (e: any, item: any, index: number) => {
    e.preventDefault();
    //hiddenFileInput.current.click();
    if (selectRadio === "inputData") {
      getInputLineData[index]?.ref.current.click();
      // e.target.value = null;
      clearInterval(getInputLineData[index].ref.current);
      //hiddenFileInput.current = null;
      // getInputLineData[index].ref.current = null;
      setSelectedItemId(item.id);
    } else {
      getMasterData[index]?.ref?.current?.click();
      // e.target.value = null;
      clearInterval(getMasterData[index]?.ref.current);
      //hiddenFileInput.current = null;
      // getMasterData[index].ref.current = null;
      setSelectedItemId(item.id);
    }
  };

  const handleChangeFileUpload = (e: any) => {
    selectedfileList.length = 0;
    const fileUploaded = e?.target?.files?.[0];
    if (!fileUploaded) return;
    selectedfileList.push(fileUploaded.name);
    selectedfilesList.push({
      filename: fileUploaded.name,
      filedata: fileUploaded,
    });
    if (!fileUploaded) {
      return;
    }

    if (selectRadio === "inputData") {
      setGetInputLineData((prev: any[]) =>
        (prev || []).map((ele: any) =>
          ele.id === selectedItemId
            ? { ...ele, selectedFile: fileUploaded }
            : ele,
        ),
      );
      // setGetMasterData(newArr);
    } else {
      setGetMasterData((prev: any[]) =>
        (prev || []).map((ele: any) =>
          ele.id === selectedItemId
            ? { ...ele, selectedFile: fileUploaded }
            : ele,
        ),
      );
    }
    setSelectedFile(fileUploaded);
  };

  const handleCancelFile = (e: any, elem: any) => {
    if (selectRadio === "inputData") {
      const newArr = getInputLineData?.filter((ele: any, i: any) => {
        if (ele.id === elem.id) {
          ele.selectedFile = {};
        }
        return ele;
      });
      setGetMasterData(newArr);
    } else {
      const newArr = getMasterData?.filter((ele: any, i: any) => {
        if (ele.id === elem.id) {
          ele.selectedFile = {};
        }
        return ele;
      });
      setGetMasterData(newArr);
    }
  };

  const callScenarioFilterApi = (params: any) => {
    const useCaseName = localStorage.getItem("selectedUsecase");
    if (
      useCaseName === "LongTermInput" ||
      useCaseName === "Long Term Analysis"
    ) {
      dispatch(displayScenarioList());
      const urls = API_BASE_URL + LONG_GETALLSCENARIOS_API;
      const header = {
        accept: "application/json",
        "Content-Type": "application/json",
      };
      getRequest(
        urls,
        { folder_id: params.id, createdBy: userData.userId },
        header,
      )
        .then((response) => {
          if (response.status === 200 && response.data) {
            let responseArray = [];
            //responseArray.push(response.data);
            //
            setScenarioOptions(response.data);
            dispatch(displayScenarioListSuccess(response.data));
          }
        })
        .catch((error) => {
          dispatch(openErrorDialog(error));
          dispatch(displayScenarioListError(error.message));
        });
    } else {
      dispatch(displayScenarioList());
      const urls = API_BASE_URL + DISPLAY_SCENARIO_FILTER_API;
      const header = {
        accept: "application/json",
        "Content-Type": "application/json",
      };
      getRequest(
        urls,
        { folder_id: params.id, createdBy: userData.userId },
        header,
      )
        .then((response) => {
          if (response.status === 200 && response.data) {
            let responseArray = [];
            setScenarioOptions(response.data);
            dispatch(displayScenarioListSuccess(response.data));
          }
        })
        .catch((error) => {
          dispatch(openErrorDialog(error));
          dispatch(displayScenarioListError(error.message));
        });
    }
  };

  const callMonthFilterApi = (scenarioId: number) => {
    const useCaseName = localStorage.getItem("selectedUsecase");
    if (useCaseName === "Long Term Analysis") {
      dispatch(displayScenarioList());
      const urls = API_BASE_URL + LONG_GETALLTIMEPERIODS_API;
      const header = {
        accept: "application/json",
        "Content-Type": "application/json",
      };

      getRequest(
        urls,
        {
          folder_id: selectedFolderId,
          scenario_id: scenarioId,
        },
        header,
      )
        .then((response) => {
          if (response.status === 200 && response.data.success) {
            setMonthNamesOptions(response.data.data);
            dispatch(displayMonthNamesListSuccess(response.data.data));
          }
        })
        .catch((error) => {
          dispatch(openErrorDialog(error));
          dispatch(displayScenarioListError(error.message));
        });
    } else {
      dispatch(displayScenarioList());
      const urls = API_BASE_URL + DISPLAY_MONTH_NAMES_API;
      const header = {
        accept: "application/json",
        "Content-Type": "application/json",
      };

      getRequest(
        urls,
        {
          usecase_id: selectedUsecaseeId,
          category_id: selectedCategoryId,
          folder_id: selectedFolderId,
          scenario_id: scenarioId,
        },
        header,
      )
        .then((response) => {
          if (response.status === 200 && response.data.success) {
            setMonthNamesOptions(response.data.data);
            dispatch(displayMonthNamesListSuccess(response.data.data));
          }
        })
        .catch((error) => {
          dispatch(openErrorDialog(error));
          dispatch(displayScenarioListError(error.message));
        });
    }
  };

  const callLongTermMonthFilterApi = (scenarioId: number) => {
    const useCaseName = localStorage.getItem("selectedUsecase");

    dispatch(displayScenarioList());
    // const urls = API_BASE_URL + GET_LONGTERM_TIMEPERIOD_API+folderModuleName
    const urls = API_BASE_URL + GET_LONGTERM_TIMEPERIOD_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };

    getRequest(
      urls,
      {
        folder_id: selectedFolderId,
        scenario_id: scenarioId,
        ModuleKey: folderModuleName,
      },
      header,
    )
      .then((response) => {
        if (response.status === 200 && response.data.success) {
          setMonthNamesOptions(response.data.data);
          dispatch(displayMonthNamesListSuccess(response.data.data));
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
        dispatch(displayScenarioListError(error.message));
      });
  };

  const nutritionCallMonthFilterApi = (scenarioId: number) => {
    dispatch(displayScenarioList());
    const urls = API_BASE_URL + NUTRITION_DISPLAY_MONTH_NAMES_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };

    getRequest(
      urls,
      {
        usecase_id: selectedUsecaseeId,
        category_id: selectedCategoryId,
        folder_id: selectedFolderId,
        scenario_id: scenarioId,
      },
      header,
    )
      .then((response) => {
        if (response.status === 200 && response.data.success) {
          // let responseArray = [];
          // responseArray.push(response.data);
          // setMonthNamesOptions(response.data);
          // dispatch(displayMonthNamesListSuccess(response.data));
          setNutritionMonthNamesOptions(response.data.data);
          dispatch(displayMonthNamesListSuccess(response.data.data));
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
        dispatch(displayScenarioListError(error.message));
      });
  };

  const mediumHomecallMonthFilterApi = (scenarioId: number) => {
    dispatch(displayScenarioList());
    const urls = API_BASE_URL + MEDIUM_HOME_DISPLAY_MONTH_NAMES_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };

    getRequest(
      urls,
      {
        usecase_id: selectedUsecaseeId,
        category_id: selectedCategoryId,
        folder_id: selectedFolderId,
        scenario_id: scenarioId,
      },
      header,
    )
      .then((response) => {
        if (response.status === 200 && response.data.success) {
          setMonthNamesOptions(response.data.data);
          dispatch(displayMonthNamesListSuccess(response.data.data));
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
        dispatch(displayScenarioListError(error.message));
      });
  };

  const mediumNutritionCallMonthFilterApi = (scenarioId: number) => {
    dispatch(displayScenarioList());
    const urls = API_BASE_URL + MEDIUM_NUTRITION_DISPLAY_MONTH_NAMES_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };

    getRequest(
      urls,
      {
        usecase_id: selectedUsecaseeId,
        category_id: selectedCategoryId,
        folder_id: selectedFolderId,
        scenario_id: scenarioId,
      },
      header,
    )
      .then((response) => {
        if (response.status === 200 && response.data.success) {
          // let responseArray = [];
          // responseArray.push(response.data);
          // setMonthNamesOptions(response.data);
          // dispatch(displayMonthNamesListSuccess(response.data));
          setNutritionMonthNamesOptions(response.data.data);
          dispatch(displayMonthNamesListSuccess(response.data.data));
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
        dispatch(displayScenarioListError(error.message));
      });
  };

  const handleChangeRadio = (e: any) => {
    setUploadStatusData([]);
    setRerunUploadStatusData([]);
    e.preventDefault();
    const value = e.target.value;
    setSelectRadio(value);
    if (value === "masterData") {
      setGetMasterData(masterData);
    } else {
      setGetMasterData(inputLine);
      //setGetInputLineData(inputLine)
    }
  };

  const handleChangeTimePeriod = (event: any) => {
    const {
      target: { value },
    } = event;
    setSelectTimePeriod(value);
    console.log(value, "valuevaluevalue");
    const filtereddata = value.filter((timePeriod: any) => {
      if (timePeriod !== "Time Period") return timePeriod;
    });
    dispatch(selectedTimePeriodSuccess(filtereddata));
  };

  const handleGurobiDownload = () => {
    if (selectedScenarioId > 0) {
      //setIsDownLoadDisable(false);
      if (selectedUsecaseId > 1) {
        if (selectedUsecaseId === 2) {
          if (selectedCategoryId === 2) {
            MediumnutritionDownloadGurobiFile();
          } else {
            MediumdownloadGurobiFile();
          }
        } else if (selectedUsecaseId === 3) {
          longTermDownloadGurobiFile();
        }
      } else {
        if (selectedCategoryId === 1) {
          downloadGurobiFile();
        } else {
          nutritionDownloadGurobiFile();
        }
      }
    } else {
      //setIsDownLoadDisable(true);
      dispatch(openErrorOrWarningDialog("Please select atleast one Scenario."));
    }
  };

  const downloadGurobiFile = async () => {
    const requestParam = {
      usecaseId: selectedUsecaseeId,
      category_Id: selectedCategoryId,
      folder_id: selectedFolderId,
      scenario_id: selectedScenarioId,
    };
    const urls = API_BASE_URL + DOWNLOAD_GUROBI_API;
    axios({
      url: urls,
      method: "post",
      responseType: "arraybuffer",
      headers: { "Content-Type": "application/json;" },
      data: requestParam,
    }).then((response) => {
      let blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      //FileSaver(blob, Date.now() + '.xlsx');
      FileSaver(blob, "Optimized Output.xlsx");
    });
  };

  const nutritionDownloadGurobiFile = async () => {
    const requestParam = {
      usecaseId: selectedUsecaseeId,
      category_Id: selectedCategoryId,
      folder_id: selectedFolderId,
      scenario_id: selectedScenarioId,
    };
    const urls = API_BASE_URL + NUTRITION_DOWNLOAD_GUROBI_API;
    axios({
      url: urls,
      method: "post",
      responseType: "arraybuffer",
      headers: { "Content-Type": "application/json;" },
      data: requestParam,
    }).then((response) => {
      let blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      //FileSaver(blob, Date.now() + '.xlsx');
      FileSaver(blob, "Nutrition Optimized Output.xlsx");
    });
  };

  const MediumdownloadGurobiFile = async () => {
    const requestParam = {
      usecaseId: selectedUsecaseeId,
      category_Id: selectedCategoryId,
      folder_id: selectedFolderId,
      scenario_id: selectedScenarioId,
    };
    const urls = API_BASE_URL + MEDIUM_DOWNLOAD_GUROBI_API;
    axios({
      url: urls,
      method: "post",
      responseType: "arraybuffer",
      headers: { "Content-Type": "application/json;" },
      data: requestParam,
    }).then((response) => {
      let blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      //FileSaver(blob, Date.now() + '.xlsx');
      FileSaver(blob, "Optimized Output.xlsx");
    });
  };

  const MediumnutritionDownloadGurobiFile = async () => {
    const requestParam = {
      usecaseId: selectedUsecaseeId,
      category_Id: selectedCategoryId,
      folder_id: selectedFolderId,
      scenario_id: selectedScenarioId,
    };
    const urls = API_BASE_URL + NUTRITION_MEDIUM_DOWNLOAD_GUROBI_API;
    axios({
      url: urls,
      method: "post",
      responseType: "arraybuffer",
      headers: { "Content-Type": "application/json;" },
      data: requestParam,
    }).then((response) => {
      let blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      //FileSaver(blob, Date.now() + '.xlsx');
      FileSaver(blob, "Nutrition Optimized Output.xlsx");
    });
  };

  const longTermDownloadGurobiFile = async () => {
    const requestParam = {
      usecaseId: selectedUsecaseeId,
      category_Id: selectedCategoryId,
      folder_id: selectedFolderId,
      scenario_id: selectedScenarioId,
    };

    let folderName = selectFolder?.slice(0, 7);
    let api = LONG_TERM_ALL_DOWNLOAD;
    if (folderName === "module2") {
      api = LONG_TERM_ALL_DOWNLOAD2;
    } else if (folderName === "module3") {
      api = LONG_TERM_ALL_DOWNLOAD3;
    } else if (folderName === "module4") {
      api = LONG_TERM_ALL_DOWNLOAD4;
    } else if (folderName === "module5") {
      api = LONG_TERM_ALL_DOWNLOAD5;
    } else if (folderName === "module6") {
      api = LONG_TERM_ALL_DOWNLOAD6;
    } else {
      api = LONG_TERM_ALL_DOWNLOAD;
    }
    const urls = API_BASE_URL + api;
    axios({
      url: urls,
      method: "post",
      responseType: "arraybuffer",
      headers: { "Content-Type": "application/json;" },
      data: requestParam,
    }).then((response) => {
      let blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      //FileSaver(blob, Date.now() + '.xlsx');
      FileSaver(blob, "Long Term Output.xlsx");
    });
  };

  const handleChangeSelectScenario = (event: any) => {
    // dispatch(selectedScenarioList());

    if (isEditEnabled === false || isEditEnabled === undefined) {
      const {
        target: { value },
      } = event;
      setSelectScenario(value.scenario);
      setIsFileUploadStatus(false);
      setSelectedScenarioId(value.scenario_id);
      // Only explicit false from API disables; missing canEdit enables (API often omits it)
      setCanEditScenario(value.canEdit !== false);
      dispatch(selectedScenarioListSuccess(value));
      dispatch(enableEditFilter(false, "handlescenario"));
      if (selectedUsecaseId === 3) {
        callLongTermMonthFilterApi(value?.scenario_id);
      } else {
        callMonthFilterApi(value?.scenario_id);
        nutritionCallMonthFilterApi(value?.scenario_id);
      }
      if (selectedUsecaseId === 1) {
        if (selectedCategoryId === 1) {
          getSummaryCostForDashboard(selectedFolderId, value?.scenario_id);
        } else {
          nutritionGetSummaryCostForDashboard(
            selectedFolderId,
            value?.scenario_id,
          );
        }
      } else if (selectedUsecaseId === 3) {
        getLongSummaryCostForDashboard(selectedFolderId, value?.scenario_id);
      } else {
        if (selectedCategoryId === 1) {
          MediumgetSummaryCostForDashboard(
            selectedFolderId,
            value?.scenario_id,
          );
        } else {
          MediumnutritionGetSummaryCostForDashboard(
            selectedFolderId,
            value?.scenario_id,
          );
        }
      }
    } else {
      setIsEditFileStatus(true);
      setCanEditScenario(false);
    }
  };

  const handleChangeSelectFolder = (event: any) => {
    setCanEditScenario(false);
    setSelectTimePeriod([]);
    if (isEditEnabled === false || isEditEnabled === undefined) {
      const {
        target: { value },
      } = event;
      setSelectFolder(value.folder);
      // setSelectedScenarioId(0);
      setSelectedFolderId(value.id);
      // setCanEditScenario(value.canEdit);
      dispatch(selectedFolderListSuccess(value));
      callScenarioFilterApi(value);
      setIsEdit(!isEdit);
      dispatch(enableEditFilter(false, "handlefolder"));
      setIsFileUploadStatus(false);

      // getSummaryCostForDashboard(selectedFolderId, value.scenario_id);
      if (selectedUsecaseId === 1) {
        setSelectScenario("");
        if (selectedCategoryId === 1) {
          getSummaryCostForDashboard(value.id, 0);
        } else {
          nutritionGetSummaryCostForDashboard(value.id, 0);
        }
      } else if (selectedUsecaseId === 3) {
        // getLongSummaryCostForDashboard(value.id, 0)
        setSelectScenario("");
      } else {
        setSelectScenario("");
        if (selectedCategoryId === 1) {
          MediumgetSummaryCostForDashboard(value?.id, 0);
        } else {
          MediumnutritionGetSummaryCostForDashboard(value?.id, 0);
        }
      }

      //callMonthFilterApi();
    } else {
      setIsEditFileStatus(true);
      setCanEditScenario(false);
    }
  };
  const handleClickSelectFolder = (event: any) => {
    if (
      selectedUsecaseId === undefined ||
      selectedUsecaseId === 0 ||
      selectedCategoryId === undefined ||
      selectedCategoryId === 0
    ) {
      //setPageIsLoaded(true);
      //setPageIsDefaultLoaded(true);
      //dispatch(openErrorDialog("Default"));
      dispatch(
        openErrorOrWarningDialog(
          "Please select atleast one usecase and category",
        ),
      );
    } else {
      //setPageIsLoaded(false);
      //setPageIsDefaultLoaded(false);
    }
  };

  const handleClickSelectScenario = (event: any) => {
    if (selectedFolderId === undefined || selectedFolderId === 0) {
      //setPageIsLoaded(true);
      //setPageIsDefaultLoaded(true);
      //dispatch(openErrorDialog("Default"));
      dispatch(
        openErrorOrWarningDialog(
          "Please select atleast one usecase, category and folder.",
        ),
      );
    } else {
      //setPageIsLoaded(false);
      //setPageIsDefaultLoaded(false);
    }
  };

  const handleClickSelectTimePeriod = (event: any) => {
    if (selectedScenarioId === undefined) {
      //setPageIsLoaded(true);
      //setPageIsDefaultLoaded(true);
      //dispatch(openErrorDialog("Default"));
      dispatch(
        openErrorOrWarningDialog(
          "Please select atleast one usecase, category, folder and scenario.",
        ),
      );
    } else {
      //setPageIsLoaded(false);
      //setPageIsDefaultLoaded(false);
    }
  };

  const setInitialValues = () => {
    setSelectFolder("");
    setSelectedFolderId(undefined);
    setSelectedScenarioId(undefined);
    dispatch(selectedTimePeriodSuccess([]));
    dispatch(selectedFolderListSuccess(0));
    dispatch(selectedScenarioListSuccess(0));
    setMonthNamesOptions([]);
    setSelectScenario("");
    setSelectTimePeriod([]);
  };
  const handleChangeUsecase = (event: any) => {
    if (isEditEnabled === false || isEditEnabled === undefined) {
      const {
        target: { value },
      } = event;
      setSelectUsecase(value.name);
      setSelectedUsecaseId(value.id);
      setIsFileUploadStatus(false);
      dispatch(selectedUsecaseListSuccess(value));
      if (value.id !== 0 && selectedCategoryId !== 0) {
        callFolderFilterApi(value.id, selectedCategoryId);
      }
      setInitialValues();
    } else {
      setIsEditFileStatus(true);
    }
  };

  const handleChangeCategory = (event: any) => {
    if (isEditEnabled === false || isEditEnabled === undefined) {
      const {
        target: { value },
      } = event;

      setSelectCategory(value.name);
      setIsFileUploadStatus(false);
      setSelectedCategoryId(value.id);
      dispatch(selectedCategoryListSuccess(value));
      setInitialValues();
      if (selectedUsecaseeId !== 0 && value.id !== 0) {
        callFolderFilterApi(selectedUsecaseeId, value.id);
      }
      // setIsEdit(!isEdit);
      dispatch(enableEditFilter(false, "handlecat"));
    } else {
      setIsEditFileStatus(true);
    }
  };

  const categoryChange = (cateory: any) => {
    if (isEditEnabled === false || isEditEnabled === undefined) {
      /* const {
        target: { value },
      } = event; */
      setSelectCategory(cateory);
      setIsFileUploadStatus(false);
      //setSelectedCategoryId(value.id);
      dispatch(selectedCategoryListSuccess(cateory));
      setInitialValues();
      dispatch(enableEditFilter(false, "handlecat"));
    } else {
      setIsEditFileStatus(true);
    }
  };

  const handleUploadData = () => {
    setfullOverlayDetails(false);

    setSelectRadio("");
    if (
      selectedUsecaseeId !== undefined &&
      selectedUsecaseeId !== 0 &&
      selectedCategoryId !== undefined &&
      selectedCategoryId !== 0
    ) {
      dispatch(selectedUsecaseListSuccess(selectedUsecaseeId));
      dispatch(selectedCategoryListSuccess(selectedCategoryId));
      // dispatch(selectedFolderListSuccess(selectedFolderId))

      if (selectedUsecaseeId === 3) {
        setIsLongTermUploadModal(true);
        // setOpenInputCapacityModalForLT(true); // Show upload progress dialog
      } else {
        if (selectedUsecaseeId === 1 || selectedUsecaseeId === 2) {
          if (isExistingScenarioSelected) {
            // open the upload master data dialog directly
            setShowMasterDataModal(true);
          }
        }
        setIsUploadHomeModal(true);
      }
    } else {
      //setPageIsLoaded(true);
      //setIsUploadReady(true);
      dispatch(
        openErrorOrWarningDialog(
          "Please select atleast one usecase and category",
        ),
      );
    }
  };

  //close modal when click on closs button
  const closeUploadModal = () => {
    // dispatch(selectedUsecaseListSuccess(selectedUsecaseeId));
    // dispatch(selectedCategoryListSuccess(selectedCategoryId));
    setIsUploadHomeModal(false);
    setIsNext(false);
    // setGetMasterData(masterData);
    setGetInputLineData((previousData: any) => previousData);
    setSelectRadio("");
    setSelectedFile({});
    setIsUploadMasterFile(false);
    dispatch(closeModal());
    dispatch(selectedUsecaseListSuccess(selectedUsecaseeId));
    dispatch(selectedCategoryListSuccess(selectedCategoryId));
    // dispatch(selectedFolderListSuccess(selectedFolderId))
    dispatch(selectedScenarioListSuccess(selectedScenarioId));
    dispatch(displayDashboardSummaryCostSuccess(dashboardSummaryCost));
  };

  const handleOpenDuplicateScenario = () => {
    if (
      selectedUsecaseeId !== undefined &&
      selectedUsecaseeId !== 0 &&
      selectedCategoryId !== undefined &&
      selectedCategoryId !== 0
    ) {
      dispatch(selectedUsecaseListSuccess(selectedUsecaseeId));
      dispatch(selectedCategoryListSuccess(selectedCategoryId));
      //setPageIsLoaded(false);

      setDuplicateScenario(true);
      dispatch(selectedUsecaseListSuccess(selectedUsecaseeId));
      dispatch(selectedCategoryListSuccess(selectedCategoryId));
    } else {
      //setPageIsLoaded(true);
      //dispatch(openErrorDialog("Default"));
      dispatch(
        openErrorOrWarningDialog(
          "Please select atleast one usecase and category",
        ),
      );
    }
  };

  const cancelDuplicate = () => {
    setDuplicateScenario(false);
  };

  const handleOpenBaseLineUploader = () => {
    setIsOpenBaseLineUploader(true);
  };

  const closeBaseLineUploader = () => {
    setIsOpenBaseLineUploader(false);
  };

  const handleCloseDonePopup = () => {
    setIsNext(false);
    setIsUploadMasterFile(false);
    dispatch(cloaseDonePopup());
    if (selectRadio === "inputData") {
      const newArr = getInputLineData.filter((ele: any, i: any) => {
        if (ele.id === selectedItemId) {
          ele.selectedFile = {};
        }
        return ele;
      });
      setGetInputLineData(newArr);
    } else {
      const newArr = getMasterData.filter((ele: any, i: any) => {
        if (ele.id === selectedItemId) {
          ele.selectedFile = {};
        }
        return ele;
      });
      setGetMasterData(newArr);
    }
    dispatch(selectedUsecaseListSuccess(selectedUsecaseeId));
    dispatch(selectedCategoryListSuccess(selectedCategoryId));
    // dispatch(selectedFolderListSuccess(selectedFolderId))
    dispatch(selectedScenarioListSuccess(selectedScenarioId));
  };

  const [intervalId, setIntervalId] = useState<any>(null);
  let statusCount = 0;
  let processingCount = 0;
  let failedCount = 0;
  let gurobiCount = 0;
  const [loading, setLoading] = useState(false);
  const [reRunloading, setReRunLoading] = useState(false);
  const selected_folder_id =
    selectedFolderId !== "" || selectedFolderId !== undefined
      ? selectedFolderId
      : uploadSelectedFolderId;

  const handleOpenApicall = (urls: any, requestParam: any) => {
    axios({
      url: urls,
      method: "post",
      headers: { "Content-Type": "application/json;" },
      data: requestParam,
    }).then((response) => {
      if (response.status === 200) {
        setUploadStatusData(response.data);
      }
    });
  };

  const handleOpen = () => {
    console.log(
      selected_folder_id,
      uploadSelectedFolderId,
      "Number(selected_folder_id)",
    );
    setOpen(true);
    setUploadStatusData([]);
    setOpenReRunDialogStatus("");
    if (
      Number(uploadSelectedFolderId) > 0 ||
      Number(uploadSelectedFolderId) !== undefined
    ) {
      const requestParam = {
        usecaseId: selectedUsecaseeId,
        category_Id: selectedCategoryId,
        folder_id:
          uploadSelectedFolderId !== ""
            ? uploadSelectedFolderId
            : selectedFolderId,
        scenario_id: uploadScenarioId === 0 ? scenario_id : uploadScenarioId,
      };

      setLoading(true);
      const urls = API_BASE_URL + PROGRESS_BAR_DETAILS_API;
      const apicallInterval = setInterval(() => {
        handleOpenApicall(urls, requestParam);
      }, 5000);
      setIntervalId(apicallInterval);
    }
  };

  useEffect(() => {
    setOpenReRunDialogStatus("");
    if (selectedCategoryId > 0 && selectedUsecaseId > 0) {
      if (isDone) {
        let isScenarioData = false;
        {
          uploadStatusData.map((item: any) => {
            item.status.includes("Gurobi")
              ? (isScenarioData = true)
              : (isScenarioData = false);
          });
        }
        {
          uploadStatusData.map((item: any) => {
            var statusstring = item.status;
            if (
              statusstring.includes("Master Successfully Completed") &&
              !isScenarioData
            ) {
              statusCount++;
              setLoading(false);
              if (intervalId !== null) {
                clearInterval(intervalId);
              }
            }
            if (statusstring.includes("Gurobi Successfully Completed")) {
              gurobiCount++;
              statusCount = 0;
              setLoading(false);
              if (intervalId !== null) {
                clearInterval(intervalId);
              }
            }
            if (statusstring?.toLowerCase().includes("processing")) {
              processingCount++;
            }
            if (statusstring?.toLowerCase().includes("failed")) {
              failedCount++;
              processingCount = 0;
              statusCount = 0;
              setLoading(false);
              if (intervalId !== null) {
                clearInterval(intervalId);
              }
            }
          });
        }

        if (
          uploadStatusData.length > 0 &&
          gurobiCount > 0 &&
          failedCount === 0
        ) {
          setOpenReRunDialogStatus("Gurobi Data uploaded successfully!");
          if (intervalId !== null) {
            clearInterval(intervalId);
          }
        }
        if (
          uploadStatusData.length > 0 &&
          statusCount > 0 &&
          failedCount === 0
        ) {
          setOpenReRunDialogStatus("Data uploaded successfully!");
          if (intervalId !== null) {
            clearInterval(intervalId);
          }
        }
        if (processingCount > 0) {
          setOpenReRunDialogStatus("Data upload in Progress");
          setLoading(true);
        }
        if (failedCount > 0) {
          setOpenReRunDialogStatus("Data upload Failed");
          ActivateOrDeactivateFolder(selectedUsecaseId, selectedFolderId, 0);
          if (intervalId !== null) {
            clearInterval(intervalId);
          }
        }
      }
    }
  }, [isDone, uploadStatusData]);

  const handleEdit = () => {
    if (
      selectedUsecaseId > 0 &&
      selectedCategoryId > 0 &&
      selectedFolderId > 0
    ) {
      dispatch(enableEditFilter(false, "handleedit"));

      setIsEdit(!isEdit);
      setOpenForEdit(true);
    }
    handleOpenCloseEditDialog();
  };

  const handleNoFolderSelectedEdit = () => {
    console.log("can not edit");
  };

  let reRunIntervalId: any;
  const rerunApiCall = (urls: any, requestParam: any) => {
    axios({
      url: urls,
      method: "post",
      headers: { "Content-Type": "application/json;" },
      data: requestParam,
    })
      .then((response) => {
        if (response?.status === 200) {
          setRerunUploadStatusData(response?.data);
          clearInterval(reRunIntervalId);
        } else {
          // dispatch(enableEditFilter(false, 'handlecat'));
          //setReRunStatus("Rerun failed");
        }
      })
      .catch((e) => {
        clearInterval(reRunIntervalId);
      });
  };

  const handleRerunData = () => {
    if (selectedCategoryId === 1) {
      const interval = setInterval(() => {
        const requestParam = {
          usecaseId: selectedUsecaseeId,
          category_Id: selectedCategoryId,
          folder_id: selectedFolderId,
          scenario_id: selectedScenarioId,
        };
        setReRunLoading(true);
        setUploadReRunStatus(true);
        const urls = API_BASE_URL + RERUN_PROGRESS_BAR_DETAILS_API;

        // const urls = API_BASE_URL + RERUN_HOMECARE_DETAILS_API;
        axios({
          url: urls,
          method: "post",
          headers: { "Content-Type": "application/json;" },
          data: requestParam,
        }).then((response) => {
          // if (response?.data?.toLowerCase() === "success") {
          setRerunUploadStatusData(response?.data);
          // }
        });
      }, 5000);
      setIntervalId(interval);

      // clearInterval(reRunIntervalId)
    } else {
      const nutritionInterval = setInterval(() => {
        const requestParam = {
          usecaseId: selectedUsecaseeId,
          category_Id: selectedCategoryId,
          folder_id: selectedFolderId,
          scenario_id: selectedScenarioId,
        };
        const urls = API_BASE_URL + RERUN_PROGRESS_BAR_DETAILS_API;
        axios({
          url: urls,
          method: "post",
          headers: { "Content-Type": "application/json;" },
          data: requestParam,
        }).then((response) => {
          // if (response?.data?.toLowerCase() === "success") {
          setUploadReRunStatus(true);
          setRerunUploadStatusData(response?.data);
          // }
        });
      }, 5000);

      setIntervalId(nutritionInterval);
      //  return()=>clearInterval(nutritionInterval);
    }
  };

  const handleLongTermRerunData = () => {
    const interval = setInterval(() => {
      const requestParam = {
        usecaseId: selectedUsecaseeId,
        category_Id: selectedCategoryId,
        folder_id: selectedFolderId,
        scenario_id: selectedScenarioId,
        module_id:
          folderModuleName === "module1"
            ? 1
            : folderModuleName === "module2"
              ? 2
              : folderModuleName === "module3"
                ? 3
                : folderModuleName === "module4"
                  ? 4
                  : folderModuleName === "module5"
                    ? 5
                    : 6,
      };
      setReRunLoading(true);
      setUploadReRunStatus(true);
      const urls = API_BASE_URL + GET_LONGTERM_RERUN_UPLOAD_API;

      // const urls = API_BASE_URL + RERUN_HOMECARE_DETAILS_API;
      axios({
        url: urls,
        method: "post",
        headers: { "Content-Type": "application/json;" },
        data: requestParam,
      }).then((response) => {
        // if (response?.data?.toLowerCase() === "success") {
        setRerunUploadStatusData(response?.data);
        // }
      });
    }, 5000);
    setIntervalId(interval);

    // clearInterval(reRunIntervalId)
  };

  const handleRerun = (e: any) => {
    setOpenReRunDialogStatus("");
    dispatch(enableEditPopupForSave(false));
    if (selectedUsecaseId === 1) {
      if (selectedCategoryId === 1) {
        const requestParam = {
          usecaseId: selectedUsecaseeId,
          category_Id: selectedCategoryId,
          folder_id: selectedFolderId,
          scenario_id: selectedScenarioId,
        };
        const urls = API_BASE_URL + RERUN_HOMECARE_DETAILS_API;

        // const urls = API_BASE_URL + RERUN_HOMECARE_DETAILS_API;
        axios({
          url: urls,
          method: "post",
          headers: { "Content-Type": "application/json;" },
          data: requestParam,
        })
          .then((response) => {
            if (response?.data?.toLowerCase() === "success") {
              //handleOpenReRunDialog();
              dispatch(enableEditFilter(false, "handlecat"));
              // setReRunStatus("Rerun Done Successfully")
              setReRunSuccess(true);
              handleRerunData();
            } else {
              handleOpenReRunDialog();
              dispatch(enableEditFilter(false, "handlecat"));
              setReRunStatus(
                "Module run is unsuccessful. Please connect with Darshan (darshan.gosalia@unilever.com) for assistance",
              );
              //handleRerunData();
            }
            // let blob = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
            //FileSaver(blob, Date.now() + '.xlsx');
            // FileSaver(blob, 'Optimized Output.xlsx');
          })
          .catch((err) => {
            handleOpenReRunDialog();
            dispatch(enableEditFilter(false, "handlecat"));
            setReRunStatus(
              "Module run is unsuccessful. Please connect with Darshan (darshan.gosalia@unilever.com) for assistance",
            );
            //handleRerunData();
          });
      } else {
        const requestParam = {
          usecaseId: selectedUsecaseeId,
          category_Id: selectedCategoryId,
          folder_id: selectedFolderId,
          scenario_id: selectedScenarioId,
        };
        const urls = API_BASE_URL + RERUN_NUTRITION_DETAILS_API;
        axios({
          url: urls,
          method: "post",
          headers: { "Content-Type": "application/json;" },
          data: requestParam,
        })
          .then((response) => {
            if (response?.data?.toLowerCase() === "success") {
              //handleOpenReRunDialog();
              dispatch(enableEditFilter(false, "handlecat"));
              // setReRunStatus("Rerun Done Successfully")

              setReRunSuccess(true);
              handleRerunData();
            } else {
              handleOpenReRunDialog();
              dispatch(enableEditFilter(false, "handlecat"));
              setReRunStatus(
                "Module run is unsuccessful. Please connect with Darshan (darshan.gosalia@unilever.com) for assistance",
              );
              //handleRerunData();
            }

            // dispatch(enableEditFilter(false, 'handlecat'));
            // let blob = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
            //FileSaver(blob, Date.now() + '.xlsx');
            // FileSaver(blob, 'Optimized Output.xlsx');
          })
          .catch((err) => {
            handleOpenReRunDialog();
            dispatch(enableEditFilter(false, "handlecat"));
            setReRunStatus(
              "Module run is unsuccessful. Please connect with Darshan (darshan.gosalia@unilever.com) for assistance",
            );
            //handleRerunData();
          });
      }
    } else if (selectedUsecaseId === 2) {
      if (selectedCategoryId === 1) {
        const requestParam = {
          usecaseId: selectedUsecaseeId,
          category_Id: selectedCategoryId,
          folder_id: selectedFolderId,
          scenario_id: selectedScenarioId,
        };
        const urls = API_BASE_URL + RERUN_MEDIUM_HOMECARE_DETAILS_API;

        // const urls = API_BASE_URL + RERUN_HOMECARE_DETAILS_API;
        axios({
          url: urls,
          method: "post",
          headers: { "Content-Type": "application/json;" },
          data: requestParam,
        })
          .then((response) => {
            if (response?.data?.toLowerCase() === "success") {
              //handleOpenReRunDialog();
              dispatch(enableEditFilter(false, "handlecat"));
              // setReRunStatus("Rerun Done Successfully")
              setReRunSuccess(true);
              handleRerunData();
            } else {
              handleOpenReRunDialog();
              dispatch(enableEditFilter(false, "handlecat"));
              setReRunStatus(
                "Module run is unsuccessful. Please connect with Darshan (darshan.gosalia@unilever.com) for assistance",
              );
              //handleRerunData();
            }
            // let blob = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
            //FileSaver(blob, Date.now() + '.xlsx');
            // FileSaver(blob, 'Optimized Output.xlsx');
          })
          .catch((err) => {
            handleOpenReRunDialog();
            dispatch(enableEditFilter(false, "handlecat"));
            setReRunStatus(
              "Module run is unsuccessful. Please connect with Darshan (darshan.gosalia@unilever.com) for assistance",
            );
            //handleRerunData();
          });
      } else {
        const requestParam = {
          usecaseId: selectedUsecaseeId,
          category_Id: selectedCategoryId,
          folder_id: selectedFolderId,
          scenario_id: selectedScenarioId,
        };
        const urls = API_BASE_URL + RERUN_MEDIUM_NUTRITION_DETAILS_API;
        axios({
          url: urls,
          method: "post",
          headers: { "Content-Type": "application/json;" },
          data: requestParam,
        })
          .then((response) => {
            if (response?.data?.toLowerCase() === "success") {
              //handleOpenReRunDialog();
              dispatch(enableEditFilter(false, "handlecat"));
              // setReRunStatus("Rerun Done Successfully")

              setReRunSuccess(true);
              handleRerunData();
            } else {
              handleOpenReRunDialog();
              dispatch(enableEditFilter(false, "handlecat"));
              setReRunStatus(
                "Module run is unsuccessful. Please connect with Darshan (darshan.gosalia@unilever.com) for assistance",
              );
              //handleRerunData();
            }

            // dispatch(enableEditFilter(false, 'handlecat'));
            // let blob = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
            //FileSaver(blob, Date.now() + '.xlsx');
            // FileSaver(blob, 'Optimized Output.xlsx');
          })
          .catch((err) => {
            handleOpenReRunDialog();
            dispatch(enableEditFilter(false, "handlecat"));
            setReRunStatus(
              "Module run is unsuccessful. Please connect with Darshan (darshan.gosalia@unilever.com) for assistance",
            );
            //handleRerunData();
          });
      }
    } else {
      const requestParam = {
        // usecaseId: selectedUsecaseeId,
        // category_Id: selectedCategoryId,
        folder_id: selectedFolderId,
        scenario_id: selectedScenarioId,
      };
      const urls = API_BASE_URL + RERUN_LONGTERM_API;
      axios({
        url: urls,
        method: "post",
        headers: { "Content-Type": "application/json;" },
        data: requestParam,
      })
        .then((response) => {
          if (response?.data?.toLowerCase() === "success") {
            //handleOpenReRunDialog();
            dispatch(enableEditFilter(false, "handlecat"));
            // setReRunStatus("Rerun Done Successfully")

            setReRunSuccess(true);
            handleLongTermRerunData();
          } else {
            handleOpenReRunDialog();
            dispatch(enableEditFilter(false, "handlecat"));
            setReRunStatus(
              "Module run is unsuccessful. Please connect with Darshan (darshan.gosalia@unilever.com) for assistance",
            );
            //handleRerunData();
          }

          // dispatch(enableEditFilter(false, 'handlecat'));
          // let blob = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
          //FileSaver(blob, Date.now() + '.xlsx');
          // FileSaver(blob, 'Optimized Output.xlsx');
        })
        .catch((err) => {
          handleOpenReRunDialog();
          dispatch(enableEditFilter(false, "handlecat"));
          setReRunStatus(
            "Module run is unsuccessful. Please connect with Darshan (darshan.gosalia@unilever.com) for assistance",
          );
          //handleRerunData();
        });
    }
  };

  let statusCountReRun = 0;
  let processingCountReRun = 0;
  let failedCountReRun = 0;
  useEffect(() => {
    if (selectedCategoryId > 0 && selectedUsecaseId > 0) {
      if (reRunSuccess) {
        rerunUploadStatusData.map((item: any) => {
          var statusstring = item.status;
          if (statusstring?.toLowerCase().includes("successfully")) {
            statusCountReRun++;
            if (intervalId !== null) {
              clearInterval(intervalId);
            }
          }
          if (statusstring?.toLowerCase().includes("Processing")) {
            processingCountReRun++;
          }
          if (statusstring?.toLowerCase().includes("failed")) {
            failedCountReRun++;
            if (intervalId !== null) {
              clearInterval(intervalId);
            }
          }
        });
      }
      if (
        rerunUploadStatusData.length > 0 &&
        statusCountReRun === rerunUploadStatusData.length
      ) {
        setReRunDialogStatus("Data uploaded successfully!");

        if (intervalId !== null) {
          clearInterval(intervalId);
        }
        setReRunLoading(false);
      }
      // if (processingCountReRun > 0) {
      //   setReRunDialogStatus("Data upload in Progress");
      // }
      if (failedCountReRun > 0) {
        setReRunDialogStatus("Data upload Failed");
        if (intervalId !== null) {
          clearInterval(intervalId);
        }
        setReRunLoading(false);
      }
    }
  }, [rerunUploadStatusData, selectedCategoryId, selectedUsecaseId]);

  // upload now button click for short term and medium term
  const handleUploadNow = (
    e: any,
    type: string,
    uploadType: string | null,
    runType: string,
  ) => {
    e.preventDefault();
    setIsFileUploadStatus(true);
    const formData = new FormData();
    const fileSelected = getInputLineData[0]?.selectedFile?.name
      ? getInputLineData
      : getMasterData;
    fileSelected.map((itm: any) => {
      if (itm.selectedFile.name) {
        formData.append("files", itm.selectedFile);
      }
    });

    // let filesList = selectedfilesList;
    const folderId = pickValidFolderId(
      uploadSelectedFolderId,
      selectedFolderId,
    );
    let initialValues = {
      usecase: selectedUsecaseeId,
      category: selectedCategoryId,
      folder: folderId,
      scenario:
        selectedScenarioId === undefined ||
        selectedScenarioId === "" ||
        Number(selectedScenarioId) === 0
          ? uploadScenarioId
          : selectedScenarioId,
    };

    let fileType = "";
    if (isUploadScenarioData) {
      fileType = "scenario";
    } else if (isUploadBaseLineData) {
      fileType = "baseline";
    } else {
      fileType = "scenario";
    }
    setFileTypeName(fileType);
    // Directly dispatch the action, no GET_SAS_URI_API call
    dispatch(
      actions.onInitUloadMasterFile(
        formData,
        selectedfilesList,
        fileType,
        initialValues,
        type,
        "",
        uploadType,
        runType,
        userData.userId,
      ),
    );
    setSelectedFilesList([]);
    handleOpen();

    setIsUploadMasterFile(true);
  };

  const handleGoBack = () => {
    dispatch(goBack());
    setIsNext(false);
  };

  const handleNext = (e: any) => {
    e.preventDefault();
    setIsNext(true);
  };

  const handleBack = (e: any) => {
    e.preventDefault();
    setIsNext(false);
    dispatch(closeModal());
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 700,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  const [open, setOpen] = React.useState(false);

  const scenarioNumber = useSelector(
    (state: any) => state.InputDataReducers.scenarioNumber,
  );

  var scenario_id = "";
  if (selectedScenarioId === "" || selectedScenarioId === 0) {
    scenario_id = scenarioNumber;
  } else {
    scenario_id = selectedScenarioId;
  }

  const handleClose = () => {
    setOpen(false);
  };

  // close uploading  file popup
  useEffect(() => {
    if (isDone) {
      setIsUploadMasterFile(false);
      // dispatch(selectBaseLineCost());
      setIsUploadHomeModal(false);
      //closeUploadModal();
      // dispatch(selectedUsecaseListSuccess(selectedUsecaseeId));
      // dispatch(selectedCategoryListSuccess(selectedCategoryId));
    }
  }, [isDone, isFolderCreated]);

  useEffect(() => {
    if (selectedUsecaseeId !== 0 && selectedCategoryId !== 0) {
      callFolderFilterApi(selectedUsecaseeId, selectedCategoryId);
    }
  }, [isFolderCreated]);

  useEffect(() => {
    // Close upload modal when an error occurs
    if (uploadMasterFileError && isUploadMasterFile) {
      setIsUploadMasterFile(false);
    }
  }, [uploadMasterFileError]);
  useEffect(() => {
    let uc = localStorage.getItem("selectedUsecase");
    let sr = localStorage.getItem("selectedRadio");
    let ucid: any;
    if (uc === "Short Term") {
      ucid = 1;
    } else if (uc === "Medium Term") {
      ucid = 2;
    } else {
      ucid = 3;
    }
    let srid = sr == "masterData" ? 1 : 2;
    setTimeout(() => {
      let e1 = {
        target: {
          value: {
            name: uc,
            id: ucid,
          },
        },
      };
      handleChangeUsecase(e1);
      let e2 = {
        target: {
          value: {
            name:
              sr === "masterData"
                ? "Integrated Processing and Packaging Facility"
                : "Separate Processing and Packaging Facilities",
            id: srid,
          },
        },
      };
      handleChangeCategory(e2);
    }, 1000);
    setTimeout(() => {
      callFolderFilterApi(ucid, srid);
    }, 2000);
  }, []);

  const handleCloseReRunStatus = () => {
    setOpenEditDialog(false);
  };

  const handleReRunDialog = () => {
    setIsEditFileStatus(false);
  };

  const handleReRunDialogStatus = () => {
    setUploadReRunStatus(false);
  };

  const handleBackDropClick = (e: any) => {
    if (modelRef.current === e.target) {
      e?.stopPropagation();
    }
  };

  const handleReRunSuccess = () => {
    setIsEditFileStatus(false);
  };
  const handleOpenCloseEditDialog = () => {
    setOpenEditDialog(true);
  };

  const handleCloseReRunDialog = () => {
    setOpenReRunDialog(false);
  };

  const handleOpenReRunDialog = () => {
    setOpenReRunDialog(true);
  };

  const LongTermName = localStorage.getItem("selectedUsecase");

  //editscenairo popup

  const handleAllowEdit = () => {
    setOpenForEdit(false);
    dispatch(enableEditPopupForSave(true)); // for displaying save button for edit
  };

  const handleNotAllowEdit = () => {
    setOpenForEdit(false);
    dispatch(enableEditFilter(false, "handleStopEdit")); // not allow for edit
  };

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  // open fileupload flow for LT

  const [folderValue, setFolderValue] = useState<any>("");
  const [scenarioValue, setScenarioValue] = useState<any>("");

  const handleCloseModalsForLT = () => {
    if (openInputCapacityModalForLT) setOpenInputCapacityModalForLT(false);
    if (isLongTermUploadModal) setIsLongTermUploadModal(false);
    if (isNextFolderModalLongTerm) setIsNextFolderModalLongTerm(false);
    if (isOpenProceedModal) setIsOpenProceedModal(false);
    localStorage.setItem("selectedUsecase", "Long Term Analysis");
  };

  const [inputCapacityModalData, setInputCapacityModalData] = useState({});

  const handleNextLongTerm = (data: any) => {
    console.log(selectRadio, "handleNextLongTerm");
    const skipFolderModal = selectRadio === "inputData" || selectRadio === "";
    setIsLongTermUploadModal(skipFolderModal);
    setIsNextFolderModalLongTerm(!skipFolderModal);
    setInputCapacityModalData(data);
    setOpenInputCapacityModalForLT(false);
  };

  const handleCloseFolder = () => {
    setIsNextFolderModalLongTerm(false);
    setOpenInputCapacityModalForLT(true);
  };

  const getNewFolderData = (data: any) => {
    setFolderValue(data.folderValue);
  };

  const handleCreateNewFolder = (data: any) => {
    dispatch(createrFolderOrScenarioError(""));
    const apiEndPoint = data.isCreateNewFolder
      ? LONG_ADD_FOLDERSCENARIO_GET_API
      : LONG_ADD_SCENARIO_GET_API;
    setFolderValue(data.folder || data.folder_id);
    delete data["isCreateNewFolder"];
    const urls = API_BASE_URL + apiEndPoint;
    const params = data;
    postRequest(urls, params, {})
      .then((response: any) => {
        if (response.status === 200 && response) {
          setScenarioValue(response?.data?.data?.split(",")[1]);
          setFolderValue(response?.data?.data?.split(",")[0]);
          if (!response.data.success) {
            // setFolderCreationErrorMessage(response.data.message);
            dispatch(createrFolderOrScenarioError(response.data.message));
          } else {
            setIsLongTermUploadModal(true);
          }
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  };

  const handleOpenFolderModalLT = () => {
    setIsLongTermUploadModal(false);
    setIsNextFolderModalLongTerm(selectRadio === "masterData");
    setOpenInputCapacityModalForLT(selectRadio !== "masterData");
  };

  const scenarioRadioSelection = localStorage.getItem("selectedScenarioRadio");
  const isCreateScenarioSelected = scenarioRadioSelection === "createScenario";
  const isExistingScenarioSelected =
    scenarioRadioSelection === "existingScenario";

  console.log(selectedFolderId, selectedScenarioId, "selectedFolderId");

  const shouldEnableUploadDataButton = (() => {
    const areFolderAndScenarioSelected =
      (selectedFolderId || selectedFolderId === 0) &&
      (selectedScenarioId || selectedScenarioId === 0);

    if (selectedUsecaseId === 1 || selectedUsecaseId === 2) {
      if (isCreateScenarioSelected) {
        return true;
      }
    }
    return areFolderAndScenarioSelected;
  })();

  /** Duplicate / Edit Scenario: folder + scenario selected, and table (or map) data has loaded */
  const enableDuplicateEditScenarioButtons =
    shouldEnableUploadDataButton && isTableloaded;

  console.log(
    selectedFolderId,
    uploadSelectedFolderId,
    selectedScenarioId,
    uploadScenarioId,
    "selectedFolderId in filtercomponent",
  );
  return (
    <>
      {isErrorOrWarningDialog && (
        // eslint-disable-next-line react/jsx-no-undef
        <ErrorOrWarningDialog
          isErrorOrWarningDialog={isErrorOrWarningDialog}
          errorOrWarningMessage={errorOrWarningMessage}
        />
      )}
      {isErrorDialog && (
        <ErrorDialog
          isErrorDialog={isErrorDialog}
          errorMessage={errorMessage}
        />
      )}
      {isBaseLineUploader && (
        <BaseLineUploading
          isOpenBaseLineUploader={isBaseLineUploader}
          handleOpenBaseLineUploader={handleOpenBaseLineUploader}
          closeBaseLineUploader={closeBaseLineUploader}
        />
      )}
      {isDone && (
        <DoneDialog
          handleCloseDonePopup={handleCloseDonePopup}
          isOpenDone={isDone}
          doneMessage={openReRunDialogStatus}
          data={[uploadStatusData, fileTypeName]}
          loading={loading}
        />
      )}
      {uploadReRunStatus && (
        <Modal
          open={uploadReRunStatus}
          onClose={handleReRunDialogStatus}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
          className="done-modal"
          ref={modelRef}
          onClick={handleBackDropClick}
        >
          <>
            <DialogContent data-keyboard="false" data-backdrop="static">
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: 600,
                  bgcolor: "background.paper",
                  border: "2px solid #000",
                  boxShadow: 24,
                  p: 4,
                  height: 400,
                  // overflowY: 'auto'
                }}
              >
                <Box>
                  <p>
                    {(reRunDialogStatus
                      ?.toLowerCase()
                      ?.includes("successfully") ||
                      reRunDialogStatus?.toLowerCase()?.includes("failed")) && (
                      <>
                        <CancelIcon
                          className="cancel-icon"
                          onClick={handleReRunDialogStatus}
                        />

                        {/* <a onClick={handleClosePopup}>Close</a> */}
                      </>
                    )}
                  </p>
                  {reRunloading && (
                    <Box>
                      <div
                        style={{
                          textAlign: "center",
                        }}
                      >
                        <CircularProgress />
                      </div>
                    </Box>
                  )}

                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>File Name</TableCell>
                          <TableCell>File Status</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rerunUploadStatusData?.map((item: any) => (
                          <TableRow>
                            <TableCell>{item.fileName}</TableCell>
                            <TableCell>{item.status}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                {openReRunDialogStatus
                  ?.toLowerCase()
                  ?.includes("successfully") ? (
                  <>
                    <h6>{openReRunDialogStatus}</h6>
                    <br />
                  </>
                ) : openReRunDialogStatus?.toLowerCase()?.includes("failed") ? (
                  <>
                    <h6 className="error-modal-message">
                      {openReRunDialogStatus}
                    </h6>
                    <br />
                    {/* <a onClick={handleClosePopup}>Close</a> */}
                  </>
                ) : (
                  <>{/* <p> props?.doneMessage</p>  */}</>
                )}

                <div style={{ alignItems: "center", textAlign: "center" }}>
                  {/* <Button onClick={handleReRunDialogStatus}>Close</Button> */}
                </div>
              </Box>
            </DialogContent>
          </>
        </Modal>
      )}

      {isEditFileStatus && (
        <Modal
          open={isEditFileStatus}
          onClose={handleReRunDialog}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 400,
              bgcolor: "background.paper",
              border: "2px solid #000",
              boxShadow: 24,
              p: 4,
            }}
          >
            <h2
              style={{ alignItems: "center", textAlign: "center" }}
              id="modal-title"
            >
              Please Re-Run!
            </h2>
            <div style={{ alignItems: "center", textAlign: "center" }}>
              <Button onClick={handleReRunDialog}>Close</Button>
            </div>
          </Box>
        </Modal>
      )}

      {openReRunDialog && (
        <Modal
          open={openReRunDialog}
          onClose={handleCloseReRunDialog}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
          data-keyboard="false"
          data-backdrop="static"
        >
          <>
            <DialogContent data-keyboard="false" data-backdrop="static">
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: 400,
                  bgcolor: "background.paper",
                  border: "2px solid #000",
                  boxShadow: 24,
                  p: 4,
                }}
              >
                <h3>{reRunStatus}</h3>

                <div style={{ alignItems: "center", textAlign: "center" }}>
                  <Button onClick={handleCloseReRunDialog}>Close</Button>
                </div>
              </Box>
            </DialogContent>
          </>
        </Modal>
        // <Loader />
      )}
      {duplicateScenario && (
        <DuplicateScenario
          isOpen={duplicateScenario}
          cancelDuplicate={cancelDuplicate}
          folderItems={folderOptions}
          useCaseId={selectedUsecaseeId}
          categoryId={selectedCategoryId}
        />
      )}
      {isOpenUploadHomeModal && (
        <UploadModal
          isOpen={isOpenUploadHomeModal}
          onClose={closeUploadModal}
          isNext={isNext}
          selectRadio={selectRadio}
          handleChangeRadio={handleChangeRadio}
          handleNext={handleNext}
          handleGoBack={handleGoBack}
          handleCloseDonePopup={handleCloseDonePopup}
          handleOpenBaseLineUploader={handleOpenBaseLineUploader}
          handleUploadNow={(e: any, runType: string) =>
            handleUploadNow(e, "uploadnow", LongTermName, runType)
          }
          handleBack={handleBack}
          isUploadMasterFile={isUploadMasterFile}
          hiddenFileInput={hiddenFileInput}
          handleCancelFile={handleCancelFile}
          handleUploadFile={handleUploadFile}
          handleChangeFileUpload={handleChangeFileUpload}
          getData={
            selectRadio === "inputData" ? getInputLineData : getMasterData
          }
          selectedfile={selectedfile}
          isUploadBaseLineData={isUploadBaseLineData}
          isUploadScenarioData={isUploadScenarioData}
          isCreateScenarioSelected={isCreateScenarioSelected}
          showMasterDataModal={showMasterDataModal}
          selectedFolderId={selectedFolderId || uploadSelectedFolderId}
          selectedScenarioId={selectedScenarioId || uploadScenarioId}
        />
      )}
      <div className="filter-component">
        <div className="grid-layout">
          <div className="four-column">
            <FormControl fullWidth className="selectDropdown">
              <InputLabel id="demo-multiple-checkbox-label">Folder</InputLabel>
              <Select
                id="simple-select-4"
                value={selectFolder}
                placeholder="Select Folder"
                onClick={handleClickSelectFolder}
                onChange={handleChangeSelectFolder}
                renderValue={(selected: any) => selected}
                className="select-short-term"
              >
                {sortedFolderNames?.map((d: any) => {
                  return (
                    <MenuItem key={d.id} value={d}>
                      {d.folder}
                      {/* {d.folder + " (" + d.time_period + ")"} */}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </div>
          <div className="four-column">
            <FormControl fullWidth>
              <InputLabel id="demo-multiple-checkbox-label">
                Scenario
              </InputLabel>
              <Select
                id="simple-select-4"
                value={selectScenario}
                placeholder="Scenario"
                onClick={handleClickSelectScenario}
                onChange={handleChangeSelectScenario}
                renderValue={(selected: any) => selected}
                className="select-short-term"
              >
                {scenarioOptions.map((d: any) => {
                  return (
                    <MenuItem key={d?.scenario_id} value={d}>
                      {d?.scenario}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </div>
          <div className="four-column">
            <FormControl fullWidth className="selectDropdown">
              <InputLabel id="demo-multiple-checkbox-label">
                Time Period
              </InputLabel>
              {LongTermName === "Long Term Analysis" ||
              selectedCategoryId === 1 ? (
                <Select
                  id="simple-select-5"
                  multiple
                  value={selectTimePeriod}
                  placeholder="Time Period"
                  onClick={handleClickSelectTimePeriod}
                  onChange={handleChangeTimePeriod}
                  renderValue={(selected: any) =>
                    selected.length > 0 ? selected.join(", ") : selected
                  }
                  className="select-short-term"
                  // input={<OutlinedInput label="Tag" />}
                >
                  {monthNameOptions.map((ele: any) => (
                    <MenuItem key={ele.id} value={ele.name}>
                      <Checkbox
                        checked={selectTimePeriod.indexOf(ele.name) > -1}
                        className="time-period-checkbox"
                      />
                      <ListItemText primary={ele.name} />
                    </MenuItem>
                  ))}
                </Select>
              ) : (
                <Select
                  id="simple-select-5"
                  multiple
                  value={selectTimePeriod}
                  placeholder="Time Period"
                  // onClick={handleClickSelectTimePeriod}
                  onChange={handleChangeTimePeriod}
                  renderValue={(selected: any) => selected.join(", ")}
                  className="select-short-term"
                  // input={<OutlinedInput label="Tag" />}
                >
                  {selectedCategoryId === 2 &&
                    nutritionMonthNameOptions?.map((ele: any) => (
                      <MenuItem key={ele.id} value={ele.name}>
                        <Checkbox
                          checked={selectTimePeriod.indexOf(ele.name) > -1}
                          className="time-period-checkbox"
                        />
                        <ListItemText primary={ele.name} />
                      </MenuItem>
                    ))}
                </Select>
              )}
            </FormControl>
          </div>

          <div
            className={
              shouldEnableUploadDataButton && canEditScenario
                ? "download-btn"
                : "disable-download-btn"
            }
            onClick={() => {
              if (shouldEnableUploadDataButton && canEditScenario) {
                handleGurobiDownload();
              }
            }}
          >
            <img src={DownloadIcon} alt="" /> <span> Download Data</span>
          </div>

          <div
            className={
              shouldEnableUploadDataButton ||
              (selectedFolderId !== null &&
                selectedScenarioId !== null &&
                canEditScenario)
                ? "upload-btn"
                : "disabled-upload-btn"
            }
            onClick={() => {
              if (
                shouldEnableUploadDataButton ||
                (selectedFolderId !== null &&
                  selectedScenarioId !== null &&
                  canEditScenario)
              ) {
                handleUploadData();
              }
            }}
          >
            <img src={UploadIcon} alt="" /> <span> Upload Data</span>
          </div>
        </div>
        <div className="clear"></div>
      </div>
      {/* {showFullOverlay && (
        <div className="firstthingfirstInfo">
          <div className="arrow-icon">
            <img src={arrowIcon} alt="" />
          </div>
          <div>
            <span>
              {" "}
              <img src={excelIcon} alt="" />
            </span>
            <span className="title">First Things First!</span>
          </div>
          <br></br>
          <div>
            You need to add your master and Input data files to start creating
            optimizations.
          </div>
          <br></br>
          <div className="footer-links">
            <span>
              <a
                href="#"
                onClick={(e) => {
                  e.stopPropagation();
                  setfullOverlayDetails(false);
                }}
              >
                Skip
              </a>
            </span>
            <span>To Explore app</span>
          </div>
        </div>
      )} */}
      {/* The layer below the upload data */}
      {/* {showFullOverlay && <div className="download-overlay"></div>} */}
      <div className="baseline-actions">
        <div className="grid-layout1">
          <div className="half-column">
            <table style={{ width: "500px" }} cellSpacing={0} cellPadding={0}>
              <tr>
                {LongTermName !== "LongTermInput" &&
                  LongTermName !== "Long Term Analysis" && (
                    <td>
                      <span>
                        <h6 className="costLabel">Base line cost</h6>
                      </span>
                      <span>
                        <Tooltip title="Base line cost">
                          <InfoIcon className="infoIcon" />
                        </Tooltip>
                      </span>
                    </td>
                  )}
                <td>
                  <span>
                    <h6 className="costLabel">Best cost scenario</h6>
                  </span>
                  <span>
                    <Tooltip title="Best cost scenario">
                      <InfoIcon className="infoIcon" />
                    </Tooltip>
                  </span>
                </td>
                <td>
                  <span>
                    <h6 className="costLabel">Scenario</h6>
                  </span>
                  <span>
                    <Tooltip title="Scenario">
                      <InfoIcon className="infoIcon" />
                    </Tooltip>
                  </span>
                </td>
              </tr>
              <tr>
                {LongTermName !== "Long Term Analysis" &&
                  LongTermName !== "LongTermInput" && (
                    <td>
                      {" "}
                      <p className="costValue" style={{ color: "black" }}>
                        ₹ {dashboardSummaryCost?.baseLineCost} Cr
                      </p>
                    </td>
                  )}
                <td>
                  {" "}
                  <p className="costValue" style={{ color: "black" }}>
                    ₹ {dashboardSummaryCost?.bestScenarioCost} Cr
                  </p>
                </td>
                <td>
                  {" "}
                  <p className="costValue" style={{ color: "black" }}>
                    ₹ {dashboardSummaryCost?.scenarioCost} Cr
                  </p>
                </td>
              </tr>
            </table>

            {/* <p className="costValue" style={{ color: "#FF2828" }}> */}
          </div>
          <div className="half-column">
            <table className="pull-right">
              <tr>
                <td>
                  <div className="flex-display">
                    {enableDuplicateEditScenarioButtons ? (
                      <>
                        {
                          <>
                            <Grid className="Duplicatescenario">
                              <div
                                className="scenario-btns"
                                onClick={handleOpenDuplicateScenario}
                              >
                                <img src={DuplicateIcon} alt="" />
                                <span>Duplicate Scenario</span>
                              </div>
                            </Grid>
                            <Grid
                              className={
                                isEditEnabled === false
                                  ? "Duplicatescenario"
                                  : "Duplicatescenario Duplicatescenario-disabled"
                              }
                            >
                              <div
                                className="scenario-btns"
                                onClick={
                                  isEditEnabled === false
                                    ? handleEdit
                                    : handleNoFolderSelectedEdit
                                }
                              >
                                <img src={EditScenario} alt="" />
                                <span className={isEditEnabled ? "" : "rerun"}>
                                  Edit Scenario
                                </span>
                              </div>
                            </Grid>
                          </>
                        }
                      </>
                    ) : (
                      <>
                        <Grid className="Duplicatescenario Duplicatescenario-disabled">
                          <div
                            className="scenario-btns"
                            onClick={handleOpenDuplicateScenario}
                          >
                            <img src={DuplicateIcon} alt="" />
                            <span>Duplicate Scenario</span>
                          </div>
                        </Grid>
                        <Grid className="Duplicatescenario Duplicatescenario-disabled">
                          <div
                            className="scenario-btns"
                            onClick={handleNoFolderSelectedEdit}
                          >
                            <img src={EditScenario} alt="" />
                            <span className="rerun">Edit Scenario</span>
                          </div>
                        </Grid>
                      </>
                    )}

                    {
                      <>
                        <Grid className="Duplicatescenario Duplicatescenario-disabled">
                          <div
                            className={
                              isEditEnabled ? "scenario-btns" : "scenario-btns1"
                            }
                            {...(isEditEnabled && { onClick: handleRerun })}
                          >
                            <img src={ReRun} alt="" />
                            <span>Re-Run</span>
                          </div>
                        </Grid>
                      </>
                    }
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>

      {isEditEnabled && (
        <Dialog
          fullScreen={fullScreen}
          open={openForEdit}
          onClose={() => setOpenForEdit(false)}
          aria-labelledby="responsive-dialog-title"
          className="Dialogbox-display"
        >
          <DialogTitle
            id="responsive-dialog-title"
            className="responsive-dialog-title-txt"
          >
            {"Confirmation for Edit"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText className="md-alert-clr">
              Are you sure you want to edit the scenario?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              className="modal-btn-b"
              onClick={handleNotAllowEdit}
              autoFocus
            >
              No
            </Button>
            <Button className="modal-btn-b" autoFocus onClick={handleAllowEdit}>
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {/* Long Term third modal */}
      {isLongTermUploadModal && (
        <LongTermUploadModal
          isOpen={isLongTermUploadModal}
          onClose={handleCloseModalsForLT}
          selectedFolderId={selectedFolderId}
          selectedScenarioId={selectedScenarioId}
          handleGoBack={handleOpenFolderModalLT}
          selectRadio={selectRadio}
          showCrossMark={true}
          getIsProcessingPackagingPlantsDiff={
            getIsProcessingPackagingPlantsDiff
          }
          getIsSourceBePartOfOptimization={getIsSourceBePartOfOptimization}
          getIsPackingPlantAddMinorIngredient={
            getIsPackingPlantAddMinorIngredient
          }
        />
      )}
      {/* Long term second page */}
      {isNextFolderModalLongTerm && (
        <FolderModal
          isOpen={isNextFolderModalLongTerm}
          onClose={handleCloseModalsForLT}
          handleCreateNewFolder={handleCreateNewFolder}
          getNewFolderData={getNewFolderData}
          inputCapacityModalData={inputCapacityModalData}
          handleGoBack={handleCloseFolder}
          getIsProcessingPackagingPlantsDiff={
            getIsProcessingPackagingPlantsDiff
          }
          getIsSourceBePartOfOptimization={getIsSourceBePartOfOptimization}
          getIsPackingPlantAddMinorIngredient={
            getIsPackingPlantAddMinorIngredient
          }
        />
      )}
      {/* Long term First modal  */}
      {openInputCapacityModalForLT && selectRadio === "masterData" && (
        <InputCapacityModal
          hideGoBackBtnICModalForLT={openInputCapacityModalForLT}
          isOpen={openInputCapacityModalForLT}
          onClose={handleCloseModalsForLT}
          isNext={isNextFolderModalLongTerm}
          handleNext={handleNextLongTerm}
          selectFolder={selectFolder}
          selectRadio={selectRadio}
          getIsProcessingPackagingPlantsDiff={
            getIsProcessingPackagingPlantsDiff
          }
          getIsSourceBePartOfOptimization={getIsSourceBePartOfOptimization}
          getIsPackingPlantAddMinorIngredient={
            getIsPackingPlantAddMinorIngredient
          }
        />
      )}
    </>
  );
}

export default FilterComponent;
function selectedUseCaseSuccess(value: any): any {
  throw new Error("Function not implemented.");
}
